module.exports = __webpack_public_path__ + "static/poster2-dc16587e599af30211e40a9583978fd2.jpg";